<script setup>
// import {
//   mdiCheck,
//   mdiEyeOutline,
//   mdiCheckboxMarkedCircleAutoOutline,
//   mdiCheckboxMarkedCirclePlusOutline,
//   mdiTextBoxOutline,
//   // mdiUpload
// } from '@mdi/js'
import { ref } from 'vue'
// import CardBox from '@/components/CardBox.vue'
import BaseDivider from '@/components/BaseDivider.vue'
import CardBoxModal from '@/components/CardBoxModal.vue'
// import NotificationBar from '@/components/NotificationBar.vue'
// import FormField from '@/components/FormField.vue'
// import FormControl from '@/components/FormControl.vue'
// import FormControlFile from '@/components/FormControlFile.vue'
// import LoaderFullPage from '@/components/LoaderFullPage.vue'
// import BaseButtons from '@/components/BaseButtons.vue'
// import BaseLevel from '@/components/BaseLevel.vue'
// import { useRouter } from 'vue-router'
// import BaseButton from '@/components/BaseButton.vue'
// import { useUserStore } from '@/stores/user_store'
// import { useTasksStore } from '@/stores/tasks'

import { parseTimestamp } from '@/timestamp-options'

// const userStore = useUserStore()
// const tasksStore = useTasksStore()
const emit = defineEmits(['close'])

defineProps({
  violation: {
    type: Object,
    required: true
  },

})
const isModalManualActive = ref(true)

function getPath(url) {
  let u = new URL(url)
  return `${u.pathname}`
}

</script>

<template>
  <CardBoxModal
    v-model="isModalManualActive"
    title="Нарушение"
    button-label="Ok"
    @confirm="isModalManualActive=false; emit('close')"
    @cancel="isModalManualActive=false; emit('close')"
    widthClass='w-11/12 md:w-4/5 lg:w-3/5 xl:w-6/12'
  >
    <div>
      <p>Уровень: {{ violation.display_type }}</p>
      <p>Описание: {{ violation?.description }}</p>
      <p>Дата/Время: {{ parseTimestamp(violation?.timestamp) }}</p>
      <p>Зафиксировал: @{{ violation?.creator.username }}</p>
      <div v-if="violation.files.length > 0" class="container mx-auto px-5 py-2 lg:px-32 lg:pt-12">
        <div class="-m-1 flex flex-wrap md:-m-2">
          <template v-for="file in violation.files" :key="file.id" >
            <div v-if="file.file" class="flex w-1/2 flex-wrap">
              <div class="w-full p-1 md:p-2">
                <img
                  alt="gallery"
                  class="block h-full w-full rounded-lg object-cover object-center"
                  :src="`${getPath(file.file)}`" />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <BaseDivider />
  </CardBoxModal>
</template>
